import { KeyboardShortcutName } from '../../../cross-team-shared/misc-services/keyboard-shortcut.service';
import { outputShortcuts } from '../annotation-shared/output-shortcuts';

export const pointCloudOutputShortcuts: KeyboardShortcutName[] = [
  ...outputShortcuts,
  'altDown',
  'altUp',
  'changeShapeVisibility',
  'copySelectedShapes',
  'toggleEnhancedPointCloud',
  'toggleOrthographicCamera',
];
